import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

export const Information = ({ infoData }) => {
    const information = infoData.map((info, index) => {
        return (
            <div
                className={`${
                    info.subData ? 'flex-col' : 'flex'
                } w-full items-start mb-2`}
            >
                <span className='font-semibold text-texts-secondary300 mr-2'>
                    {index + 1}.
                </span>
                <span>{info.data}</span>
                {info.subData && (
                    <div className='flex-col items-center text-sm ml-6'>
                        {info.subData.map((subInfo, index) => {
                            return <li>{subInfo}</li>;
                        })}
                    </div>
                )}
            </div>
        );
    });
    return (
        <>
            <div className='w-full flex items-center font-semibold text-texts-secondary300 p-2 rounded-t-xl border '>
                <FontAwesomeIcon
                    icon={faInfoCircle}
                    className='mr-2'
                    title='Information'
                />
                <div>Information</div>
            </div>

            <div className='border-b border-x rounded-b-xl p-3 bg-backgrounds-white'>
                <div className='w-full flex-col items-center text-sm'>
                    {information}
                </div>
            </div>
        </>
    );
};
